module.exports = __webpack_public_path__ + "static/media/mw12.930c8053.webp";